import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/client-1.jpg'
import _imports_1 from '@/assets/images/client-2.jpg'
import _imports_2 from '@/assets/images/client-3.jpg'
import _imports_3 from '@/assets/images/client-4.jpg'
import _imports_4 from '@/assets/images/client-5.jpg'
import _imports_5 from '@/assets/images/client-6.jpg'
import _imports_6 from '@/assets/images/client-7.jpg'
import _imports_7 from '@/assets/images/client-8.jpg'
import _imports_8 from '@/assets/images/client-9.jpg'
import _imports_9 from '@/assets/images/client-10.jpg'
import _imports_10 from '@/assets/images/client-11.jpg'
import _imports_11 from '@/assets/images/client-12.jpg'


const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_7 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_8 = { class: "card-body p-4" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_11 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_12 = { class: "card-body p-4" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_15 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_16 = { class: "card-body p-4" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_19 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_20 = { class: "card-body p-4" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_23 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_24 = { class: "card-body p-4" }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_27 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_28 = { class: "card-body p-4" }
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_31 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_32 = { class: "card-body p-4" }
const _hoisted_33 = { class: "d-flex align-items-center" }
const _hoisted_34 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_35 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_36 = { class: "card-body p-4" }
const _hoisted_37 = { class: "d-flex align-items-center" }
const _hoisted_38 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_39 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_40 = { class: "card-body p-4" }
const _hoisted_41 = { class: "d-flex align-items-center" }
const _hoisted_42 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_43 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_44 = { class: "card-body p-4" }
const _hoisted_45 = { class: "d-flex align-items-center" }
const _hoisted_46 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_47 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_48 = { class: "card-body p-4" }
const _hoisted_49 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"d-flex\"><div class=\"flex-shrink-0\"><div class=\"bg-body pe-3 pb-3 bg-for-dark-mode\"><img src=\"" + _imports_0 + "\" class=\"wh-80 rounded-3\" alt=\"client\"></div></div><div class=\"flex-grow-1 p-20 pb-0\"><h4 class=\"mb-1 fs-16 fw-semibold\">CodeCraft</h4><span>info@codecraft.com</span></div></div>", 1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createStaticVNode("<ul class=\"ps-0 mb-4 list-unstyled\"><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Name: </span><span class=\"fw-medium text-secondary\">Olivia Taylor</span></li><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Phone: </span><span class=\"fw-medium text-secondary\">(555) 555-5555</span></li><li class=\"mb-0\"><span class=\"fw-medium\">Projects: </span><span class=\"fw-medium text-secondary\">12</span></li></ul>", 1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_RouterLink, {
              to: "/apps/chat",
              class: "btn btn-primary py-2 fw-medium"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" Message ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/project-management/project-overview",
              class: "btn btn-outline-primary py-2 fw-medium ms-3"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" View Project ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"d-flex\"><div class=\"flex-shrink-0\"><div class=\"bg-body pe-3 pb-3 bg-for-dark-mode\"><img src=\"" + _imports_1 + "\" class=\"wh-80 rounded-3\" alt=\"client\"></div></div><div class=\"flex-grow-1 p-20 pb-0\"><h4 class=\"mb-1 fs-16 fw-semibold\">ByteSavvy</h4><span>info@bytesavvy.com</span></div></div>", 1)),
        _createElementVNode("div", _hoisted_8, [
          _cache[6] || (_cache[6] = _createStaticVNode("<ul class=\"ps-0 mb-4 list-unstyled\"><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Name: </span><span class=\"fw-medium text-secondary\">David Smith</span></li><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Phone: </span><span class=\"fw-medium text-secondary\">(555) 123-4567</span></li><li class=\"mb-0\"><span class=\"fw-medium\">Projects: </span><span class=\"fw-medium text-secondary\">16</span></li></ul>", 1)),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_RouterLink, {
              to: "/apps/chat",
              class: "btn btn-primary py-2 fw-medium"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" Message ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/project-management/project-overview",
              class: "btn btn-outline-primary py-2 fw-medium ms-3"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode(" View Project ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"d-flex\"><div class=\"flex-shrink-0\"><div class=\"bg-body pe-3 pb-3 bg-for-dark-mode\"><img src=\"" + _imports_2 + "\" class=\"wh-80 rounded-3\" alt=\"client\"></div></div><div class=\"flex-grow-1 p-20 pb-0\"><h4 class=\"mb-1 fs-16 fw-semibold\">DataTech</h4><span>info@datatech.com</span></div></div>", 1)),
        _createElementVNode("div", _hoisted_12, [
          _cache[10] || (_cache[10] = _createStaticVNode("<ul class=\"ps-0 mb-4 list-unstyled\"><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Name: </span><span class=\"fw-medium text-secondary\">Alice Johnson</span></li><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Phone: </span><span class=\"fw-medium text-secondary\">(555) 234-5678</span></li><li class=\"mb-0\"><span class=\"fw-medium\">Projects: </span><span class=\"fw-medium text-secondary\">07</span></li></ul>", 1)),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_RouterLink, {
              to: "/apps/chat",
              class: "btn btn-primary py-2 fw-medium"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode(" Message ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/project-management/project-overview",
              class: "btn btn-outline-primary py-2 fw-medium ms-3"
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode(" View Project ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"d-flex\"><div class=\"flex-shrink-0\"><div class=\"bg-body pe-3 pb-3 bg-for-dark-mode\"><img src=\"" + _imports_3 + "\" class=\"wh-80 rounded-3\" alt=\"client\"></div></div><div class=\"flex-grow-1 p-20 pb-0\"><h4 class=\"mb-1 fs-16 fw-semibold\">CyberByte</h4><span>info@cyberbyte.com</span></div></div>", 1)),
        _createElementVNode("div", _hoisted_16, [
          _cache[14] || (_cache[14] = _createStaticVNode("<ul class=\"ps-0 mb-4 list-unstyled\"><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Name: </span><span class=\"fw-medium text-secondary\">Emily Brown</span></li><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Phone: </span><span class=\"fw-medium text-secondary\">(555) 345-6789</span></li><li class=\"mb-0\"><span class=\"fw-medium\">Projects: </span><span class=\"fw-medium text-secondary\">05</span></li></ul>", 1)),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_RouterLink, {
              to: "/apps/chat",
              class: "btn btn-primary py-2 fw-medium"
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode(" Message ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/project-management/project-overview",
              class: "btn btn-outline-primary py-2 fw-medium ms-3"
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode(" View Project ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"d-flex\"><div class=\"flex-shrink-0\"><div class=\"bg-body pe-3 pb-3 bg-for-dark-mode\"><img src=\"" + _imports_4 + "\" class=\"wh-80 rounded-3\" alt=\"client\"></div></div><div class=\"flex-grow-1 p-20 pb-0\"><h4 class=\"mb-1 fs-16 fw-semibold\">NetGen</h4><span>info@netgen.com</span></div></div>", 1)),
        _createElementVNode("div", _hoisted_20, [
          _cache[18] || (_cache[18] = _createStaticVNode("<ul class=\"ps-0 mb-4 list-unstyled\"><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Name: </span><span class=\"fw-medium text-secondary\">James Wilson</span></li><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Phone: </span><span class=\"fw-medium text-secondary\">(555) 456-7890</span></li><li class=\"mb-0\"><span class=\"fw-medium\">Projects: </span><span class=\"fw-medium text-secondary\">14</span></li></ul>", 1)),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_RouterLink, {
              to: "/apps/chat",
              class: "btn btn-primary py-2 fw-medium"
            }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                _createTextVNode(" Message ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/project-management/project-overview",
              class: "btn btn-outline-primary py-2 fw-medium ms-3"
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createTextVNode(" View Project ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"d-flex\"><div class=\"flex-shrink-0\"><div class=\"bg-body pe-3 pb-3 bg-for-dark-mode\"><img src=\"" + _imports_5 + "\" class=\"wh-80 rounded-3\" alt=\"client\"></div></div><div class=\"flex-grow-1 p-20 pb-0\"><h4 class=\"mb-1 fs-16 fw-semibold\">TechFuse</h4><span>info@techfuse.com</span></div></div>", 1)),
        _createElementVNode("div", _hoisted_24, [
          _cache[22] || (_cache[22] = _createStaticVNode("<ul class=\"ps-0 mb-4 list-unstyled\"><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Name: </span><span class=\"fw-medium text-secondary\">Michael Jones</span></li><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Phone: </span><span class=\"fw-medium text-secondary\">(555) 567-8901</span></li><li class=\"mb-0\"><span class=\"fw-medium\">Projects: </span><span class=\"fw-medium text-secondary\">18</span></li></ul>", 1)),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_RouterLink, {
              to: "/apps/chat",
              class: "btn btn-primary py-2 fw-medium"
            }, {
              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                _createTextVNode(" Message ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/project-management/project-overview",
              class: "btn btn-outline-primary py-2 fw-medium ms-3"
            }, {
              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                _createTextVNode(" View Project ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _cache[27] || (_cache[27] = _createStaticVNode("<div class=\"d-flex\"><div class=\"flex-shrink-0\"><div class=\"bg-body pe-3 pb-3 bg-for-dark-mode\"><img src=\"" + _imports_6 + "\" class=\"wh-80 rounded-3\" alt=\"client\"></div></div><div class=\"flex-grow-1 p-20 pb-0\"><h4 class=\"mb-1 fs-16 fw-semibold\">CodeGen</h4><span>info@codegen.com</span></div></div>", 1)),
        _createElementVNode("div", _hoisted_28, [
          _cache[26] || (_cache[26] = _createStaticVNode("<ul class=\"ps-0 mb-4 list-unstyled\"><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Name: </span><span class=\"fw-medium text-secondary\">Sophia Martinez</span></li><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Phone: </span><span class=\"fw-medium text-secondary\">(555) 678-9012</span></li><li class=\"mb-0\"><span class=\"fw-medium\">Projects: </span><span class=\"fw-medium text-secondary\">34</span></li></ul>", 1)),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_RouterLink, {
              to: "/apps/chat",
              class: "btn btn-primary py-2 fw-medium"
            }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createTextVNode(" Message ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/project-management/project-overview",
              class: "btn btn-outline-primary py-2 fw-medium ms-3"
            }, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                _createTextVNode(" View Project ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _cache[31] || (_cache[31] = _createStaticVNode("<div class=\"d-flex\"><div class=\"flex-shrink-0\"><div class=\"bg-body pe-3 pb-3 bg-for-dark-mode\"><img src=\"" + _imports_7 + "\" class=\"wh-80 rounded-3\" alt=\"client\"></div></div><div class=\"flex-grow-1 p-20 pb-0\"><h4 class=\"mb-1 fs-16 fw-semibold\">WebWiz</h4><span>info@webwiz.com</span></div></div>", 1)),
        _createElementVNode("div", _hoisted_32, [
          _cache[30] || (_cache[30] = _createStaticVNode("<ul class=\"ps-0 mb-4 list-unstyled\"><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Name: </span><span class=\"fw-medium text-secondary\">William Davis</span></li><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Phone: </span><span class=\"fw-medium text-secondary\">(555) 789-0123</span></li><li class=\"mb-0\"><span class=\"fw-medium\">Projects: </span><span class=\"fw-medium text-secondary\">08</span></li></ul>", 1)),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_RouterLink, {
              to: "/apps/chat",
              class: "btn btn-primary py-2 fw-medium"
            }, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                _createTextVNode(" Message ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/project-management/project-overview",
              class: "btn btn-outline-primary py-2 fw-medium ms-3"
            }, {
              default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                _createTextVNode(" View Project ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _cache[35] || (_cache[35] = _createStaticVNode("<div class=\"d-flex\"><div class=\"flex-shrink-0\"><div class=\"bg-body pe-3 pb-3 bg-for-dark-mode\"><img src=\"" + _imports_8 + "\" class=\"wh-80 rounded-3\" alt=\"client\"></div></div><div class=\"flex-grow-1 p-20 pb-0\"><h4 class=\"mb-1 fs-16 fw-semibold\">ByteTech</h4><span>info@bytetech.com</span></div></div>", 1)),
        _createElementVNode("div", _hoisted_36, [
          _cache[34] || (_cache[34] = _createStaticVNode("<ul class=\"ps-0 mb-4 list-unstyled\"><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Name: </span><span class=\"fw-medium text-secondary\">Ava Anderson</span></li><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Phone: </span><span class=\"fw-medium text-secondary\">(555) 890-1234</span></li><li class=\"mb-0\"><span class=\"fw-medium\">Projects: </span><span class=\"fw-medium text-secondary\">03</span></li></ul>", 1)),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_RouterLink, {
              to: "/apps/chat",
              class: "btn btn-primary py-2 fw-medium"
            }, {
              default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                _createTextVNode(" Message ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/project-management/project-overview",
              class: "btn btn-outline-primary py-2 fw-medium ms-3"
            }, {
              default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                _createTextVNode(" View Project ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _cache[39] || (_cache[39] = _createStaticVNode("<div class=\"d-flex\"><div class=\"flex-shrink-0\"><div class=\"bg-body pe-3 pb-3 bg-for-dark-mode\"><img src=\"" + _imports_9 + "\" class=\"wh-80 rounded-3\" alt=\"client\"></div></div><div class=\"flex-grow-1 p-20 pb-0\"><h4 class=\"mb-1 fs-16 fw-semibold\">CloudFlex</h4><span>info@cloudflex.com</span></div></div>", 1)),
        _createElementVNode("div", _hoisted_40, [
          _cache[38] || (_cache[38] = _createStaticVNode("<ul class=\"ps-0 mb-4 list-unstyled\"><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Name: </span><span class=\"fw-medium text-secondary\">Ethan Thomas</span></li><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Phone: </span><span class=\"fw-medium text-secondary\">(555) 901-2345</span></li><li class=\"mb-0\"><span class=\"fw-medium\">Projects: </span><span class=\"fw-medium text-secondary\">10</span></li></ul>", 1)),
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_component_RouterLink, {
              to: "/apps/chat",
              class: "btn btn-primary py-2 fw-medium"
            }, {
              default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                _createTextVNode(" Message ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/project-management/project-overview",
              class: "btn btn-outline-primary py-2 fw-medium ms-3"
            }, {
              default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                _createTextVNode(" View Project ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, [
        _cache[43] || (_cache[43] = _createStaticVNode("<div class=\"d-flex\"><div class=\"flex-shrink-0\"><div class=\"bg-body pe-3 pb-3 bg-for-dark-mode\"><img src=\"" + _imports_10 + "\" class=\"wh-80 rounded-3\" alt=\"client\"></div></div><div class=\"flex-grow-1 p-20 pb-0\"><h4 class=\"mb-1 fs-16 fw-semibold\">WebWorx</h4><span>info@webWorx.com</span></div></div>", 1)),
        _createElementVNode("div", _hoisted_44, [
          _cache[42] || (_cache[42] = _createStaticVNode("<ul class=\"ps-0 mb-4 list-unstyled\"><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Name: </span><span class=\"fw-medium text-secondary\">Isabella Clark</span></li><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Phone: </span><span class=\"fw-medium text-secondary\">(555) 012-3456</span></li><li class=\"mb-0\"><span class=\"fw-medium\">Projects: </span><span class=\"fw-medium text-secondary\">25</span></li></ul>", 1)),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_RouterLink, {
              to: "/apps/chat",
              class: "btn btn-primary py-2 fw-medium"
            }, {
              default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                _createTextVNode(" Message ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/project-management/project-overview",
              class: "btn btn-outline-primary py-2 fw-medium ms-3"
            }, {
              default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                _createTextVNode(" View Project ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _cache[47] || (_cache[47] = _createStaticVNode("<div class=\"d-flex\"><div class=\"flex-shrink-0\"><div class=\"bg-body pe-3 pb-3 bg-for-dark-mode\"><img src=\"" + _imports_11 + "\" class=\"wh-80 rounded-3\" alt=\"client\"></div></div><div class=\"flex-grow-1 p-20 pb-0\"><h4 class=\"mb-1 fs-16 fw-semibold\">TechSync</h4><span>info@techsync.com</span></div></div>", 1)),
        _createElementVNode("div", _hoisted_48, [
          _cache[46] || (_cache[46] = _createStaticVNode("<ul class=\"ps-0 mb-4 list-unstyled\"><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Name: </span><span class=\"fw-medium text-secondary\">Alexander Lewis</span></li><li class=\"mb-2 pb-1\"><span class=\"fw-medium\">Phone: </span><span class=\"fw-medium text-secondary\">(555) 210-9876</span></li><li class=\"mb-0\"><span class=\"fw-medium\">Projects: </span><span class=\"fw-medium text-secondary\">15</span></li></ul>", 1)),
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_component_RouterLink, {
              to: "/apps/chat",
              class: "btn btn-primary py-2 fw-medium"
            }, {
              default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                _createTextVNode(" Message ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/project-management/project-overview",
              class: "btn btn-outline-primary py-2 fw-medium ms-3"
            }, {
              default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                _createTextVNode(" View Project ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}